import SegmentsField from '@admin/components/mjson_designer/components/segmentsfield'
import LinkField from '@admin/components/mjson_designer/components/linkfield'
import { normalizeConfig } from '../../../utils'
import Form from '@admin/components/form'
import * as styles from '../styles'
import settings from '../settings'
import PropTypes from 'prop-types'
import React from 'react'

class Column extends React.PureComponent {

  static contextTypes = {
    form: PropTypes.object
  }

  static propTypes = {
    device: PropTypes.string,
    entity: PropTypes.object,
    parent: PropTypes.object,
    theme: PropTypes.object,
    type: PropTypes.string,
    website: PropTypes.object,
    onChange: PropTypes.func,
    onDone: PropTypes.func
  }

  formRef = React.createRef()

  _handleCancel = this._handleCancel.bind(this)
  _handleDone = this._handleDone.bind(this)
  _handleSubmit = this._handleSubmit.bind(this)
  _handleUpdate = this._handleUpdate.bind(this)

  constructor(props) {
    super(props)
    const { entity } = props
    this.state = {
      default: entity,
      config: entity
    }
  }

  render() {
    return <Form { ...this._getForm() } />
  }

  componentDidUpdate(prevProps, prevState) {
    const { config } = this.state
    if(!_.isEqual(config, prevState.config)) {
      this._handleChange()
    }
  }

  _getForm() {
    const { device, entity, type, theme, website } = this.props
    const { config } = this.state
    return {
      ref: this.formRef,
      onChange: this._handleUpdate,
      onSuccess: this._handleDone,
      showHeader: false,
      buttons: [
        { label: 't(Cancel)', color: 'blue', basic: true, handler: this._handleCancel },
        { label: 't(Done)', color: 'blue', handler: this._handleSubmit }
      ],
      tabs: [
        {
          label: 't(Content)',
          sections: [
            {
              fields: [
                { label: 't(Blocks)', name: 'content.children', type: SegmentsField, entity: 'page_block', theme, defaultValue: config.content.children },
                { label: 't(Link To)', name: 'content.link', type: LinkField, theme, defaultValue: config.content.link }
              ]
            }
          ]
        },
        {
          label: 't(Styles)',
          sections: [
            {
              label: 't(Blocks)',
              instructions: 't(Specify how blocks should behave within this column)',
              collapsing: true,
              collapsed: true,
              fields: [
                { label: 't(Display)', type: 'segment', fields: [
                  { name: 'styles.blockDisplay', type: 'radiogroup', options: [
                    { value: 'block', text: 't(Arrange Vertically)' },
                    { value: 'inline', text: 't(Arrange Horizontally)' }
                  ], defaultValue: 'block', value: config.styles.blockDisplay },
                  { label: 't(Horizontal Alignment)', name: 'styles.blockHorizontalAlign', type: 'dropdown', options: [
                    { value: 'left', text: 't(Left)' },
                    { value: 'center', text: 't(Center)' },
                    { value: 'right', text: 't(Right)' },
                    { value: 'fill', text: 't(Fill)' },
                    { value: 'around', text: 't(Space Around)' },
                    { value: 'between', text: 't(Space Between)' },
                    { value: 'evenly', text: 't(Space Evenly)' }
                  ], defaultValue: 'left', value: config.styles.blockHorizontalAlign },
                  { label: 't(Vertical Alignment)', name: 'styles.blockVerticalAlign', type: 'dropdown', options: [
                    { value: 'top', text: 't(Top)' },
                    { value: 'middle', text: 't(Middle)' },
                    { value: 'bottom', text: 't(Bottom)' },
                    { value: 'fill', text: 't(Fill)' },
                    { value: 'around', text: 't(Space Around)' },
                    { value: 'between', text: 't(Space Between)' },
                    { value: 'evenly', text: 't(Space Evenly)' }
                  ], defaultValue: 'top', value: config.styles.blockVerticalAlign }
                ] }
              ]
            },
            styles.BackgroundSection(config, device, theme, website, type),
            styles.BoxShadowSection(config, device, theme, website, type),
            styles.BorderSection(config, device, theme, website, type),
            styles.SizingSection(config, device, theme, website, type, true, true),
            styles.SpacingSection(config, device, theme, website, type),
            styles.TransformSection(config, device, theme, website, type),
            styles.AnimationSection(config, device, theme, website, type),
            styles.FiltersSection(config, device, theme, website, type),
            styles.OverflowSection(config, device, theme, website, type),
            styles.VisibilitySection(config, device, theme, website, type)
          ]
        },
        {
          label: 't(Settings)',
          sections: settings(config, type, entity)
        }
      ]
    }
  }

  _getNormalized() {
    const { entity } = this.props
    const { config } = this.state
    return normalizeConfig({
      ...entity,
      meta: config.meta,
      settings: config.settings,
      styles: config.styles,
      content: config.content
    })
  }

  _handleCancel() {
    this.props.onDone(this.state.default)
  }

  _handleChange() {
    const config = this._getNormalized()
    this.props.onChange(config)
  }

  _handleDone() {
    const config = this._getNormalized()
    this.props.onDone(config)
  }

  _handleSubmit() {
    this.formRef.current.submit()
  }

  _handleUpdate(config) {
    this.setState({
      config: {
        ...this.state.config,
        ...config
      }
    })
  }

}

export default Column
